// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p1-0";
export var animationContainer = "_p1-1";
export var itemPrice = "_p1-a";
export var itemizedContent = "_p1-9";
export var itemizedHeader = "_p1-7";
export var itemizedRow = "_p1-8";
export var itemizedSection = "_p1-6";
export var modalContent = "_p1-2";
export var orderName = "_p1-3";
export var refundOption = "_p1-4";
export var refundOptionsContainer = "_p1-5";
export var shippingLabel = "_p1-b";
export var totalRow = "_p1-c";